import { FormGroup, Paper, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ResponsiveTextField = styled(TextField)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.up('md')]: {
    width: '90%',
  },
}));

export const ResponsiveFormGroup = styled(FormGroup)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.up('md')]: {
    width: '90%',
  },
}));

export const ResponsivePaper = styled(Paper)(({ theme }) => ({
  padding: '2em',
  width: '100%',
  [theme.breakpoints.up('md')]: {
    width: '80%',
  },
}));
